import axios from 'axios';
import { Message } from 'element-ui';
import { router } from "@/router"
const Config = {
  baseURL: process.env.NODE_ENV == "development" ? "http://localhost" : "https://api.xm.xi-life.cn"
}
var instance = axios.create({ timeout: 1000 * 100 });
instance.interceptors.request.use(
  config => {
    config.baseURL = Config.baseURL;
    let token = localStorage.getItem('admin.access_token')
      ? 'bearer ' + localStorage.getItem('admin.access_token')
      : '';
    if (token) {
      config.headers = {
        Authorization: token,
      };
    }
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  response => {
    return Promise.resolve(response);
  },
  error => {
    if (error.response.status == 401) {
      // 刷新token
      let config = error.response.config;
      if (localStorage.getItem('admin.refresh_token')) {
        return axios.get(Config.baseURL + '/xsss/v1/refreshtoken', {
          params: {
            refreshtoken: localStorage.getItem('admin.refresh_token'),
          }
        })
          .then(res => {
            localStorage.setItem('admin.access_token', res.data.access_token);
            localStorage.setItem('admin.refresh_token', res.data.refresh_token);
            config.headers.Authorization = `bearer ` + res.data.access_token;
            config.baseURL = Config.baseURL;
            return axios(config);
          })
          .catch(err => {
            localStorage.clear();
            router.push("/login");
            return Promise.reject(err);
          });
      } else {
        Message({
          message: '登录过期，请重新登录',
          type: 'error',
          duration: 3 * 1000
        })
        router.push("/login");
      }
    } else {
      return Promise.reject(error);
    }
  }
);
export default {
  axios,
  get(url, param, other) {
    return new Promise((resolve, reject) => {
      instance({
        method: 'get',
        url,
        params: param,
        ...other,
      })
        .then(res => {
          if (res.status == 200) {
            resolve(res); //resolve在promise执行器内部
          } else {
            console.log(res, '异常1');
            reject(res);
          }
        })
        .catch(err => {
          if (!err.response) {
            Message({
              message: "请求错误",
              type: "error",
              duration: 3 * 1000
            });
          } else {
            reject(err.response);
            Message({
              message: err.response.data[0],
              type: 'error',
              customClass: 'self-message',
              duration: 3 * 1000,
            });
          }
        });
    });
  },

  //post
  post(url, param, other) {
    return new Promise((resolve, reject) => {
      instance({
        method: 'post',
        url,
        data: param,
        ...other,
      })
        .then(res => {
          //axios返回的是一个promise对象
          if (res.status == 200) {
            resolve(res); //resolve在promise执行器内部
          } else {
            console.log(res, '异常1');
          }
        })
        .catch(err => {
          if (!err.response) {
            reject('cancel');
            console.log('请求错误');
            // Message({
            //     message: '请求错误',
            //     type: 'error',
            //     duration: 3 * 1000
            // })
          } else {
            Message({
              message: err.response.data[0],
              type: 'error',
              duration: 3 * 1000,
              customClass: 'self-message',
            });
            reject(err.response);
            console.log(err.response.data[0], '异常2');
          }
        });
    });
  },
  //post
  delete(url, param) {
    return new Promise((resolve, reject) => {
      instance({
        method: 'delete',
        url,
        data: param,
      })
        .then(res => {
          //axios返回的是一个promise对象
          if (res.status == 200) {
            resolve(res); //resolve在promise执行器内部
          } else {
            console.log(res, '异常1');
          }
        })
        .catch(err => {
          if (!err.response) {
            console.log('请求错误');
            // Message({
            //     message: '请求错误',
            //     type: 'error',
            //     duration: 3 * 1000
            // })
          } else {
            Message({
              message: err.response.data[0],
              type: 'error',
              duration: 3 * 1000,
              customClass: 'self-message',
            });
            reject(err.response);
            console.log(err.response.data[0], '异常2');
          }
        });
    });
  },
  //put
  put(url, param) {
    return new Promise((resolve, reject) => {
      instance({
        method: 'put',
        url,
        data: param,
      })
        .then(res => {
          //axios返回的是一个promise对象
          if (res.status == 200) {
            resolve(res); //resolve在promise执行器内部
          } else {
            console.log(res, '异常1');
          }
        })
        .catch(err => {
          if (!err.response) {
            console.log('请求错误');
            // Message({
            //     message: '请求错误',
            //     type: 'error',
            //     duration: 3 * 1000
            // })
          } else {
            Message({
              message: err.response.data[0],
              type: 'error',
              duration: 3 * 1000,
              customClass: 'self-message',
            });
            reject(err.response);
            console.log(err.response.data[0], '异常2');
          }
        });
    });
  },
  downLoad(url, param) {
    return new Promise((resolve, reject) => {
      instance({
        method: 'get',
        url,
        params: param,
        responseType: 'blob',
      })
        .then(res => {
          // console.log('ce',res.status)
          //axios返回的是一个promise对象
          if (res.status == 200) {
            resolve(res); //resolve在promise执行器内部
          } else {
            console.log(res, '异常1');
            // Message({
            //     message: '成功',
            //     type: 'success',
            //     duration: 3 * 1000
            // })
          }
        })
        .catch(err => {
          if (!err.response) {
            // Message({
            //   message: "请求错误",
            //   type: "error",
            //   duration: 3 * 1000
            // });
          } else {
            reject(err.response);
            Message({
              message: err.response.data[0],
              type: 'error',
              duration: 3 * 1000,
              customClass: 'self-message',
            });
          }
        });
    });
  },
};
